import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getRoleScopeColumnMappings, isNullOrEmpty, laaSFormatString, onDropdownKeydown } from 'src/app/core/utils/common-functions';
import { ExportDeclarationFirstConditionDto, BookingService } from '../../services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { catchError, finalize } from 'rxjs/operators';
import { ConfirmEventType, MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { TmsService } from '../../services/tms.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { LaasOption } from 'src/app/core/models/laas-option';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { downloadExpressInvoiceRequest } from './interface/downloadExpressInvoiceRequest';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CopyBillBookingRequest } from 'src/app/core/models/transport-operation/copy-bill-booking-request';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { SearchFormParameterGroupComponent } from 'src/app/shared/components/search-form-parameter-group/search-form-parameter-group.component';
import { firstValueFrom, lastValueFrom, tap, forkJoin, of, combineLatest, concat } from 'rxjs';
import { FileCategory } from 'src/app/core/constants/file-category.constant';
import { ActivatedRoute, Params } from '@angular/router';
import { FrontlineDocumentComponent } from '../../components/frontline-document/frontline-document.component';
import { FacilityForwarder } from 'src/app/core/models/facility-forwarder';
import { CodeConverterOptions } from 'src/app/core/models/options/code-converter-options';
import { ForwarderFetchFedExPodByFacilityAndBookingNoRequest } from 'src/app/features/transport-operation/pages/booking-search/interface/forwarderFetchFedExPodByFacilityAndBookingNoRequest';


@Component({
  selector: 'laas-booking-search',
  templateUrl: './booking-search.component.html',
  styleUrls: ['./booking-search.component.scss']
})
export class BookingSearchComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode = PermissionConstants.ViewQueryBookingForShipping;
  readonly permissionCodeForChangeBookingDetailStatus = PermissionConstants.ChangeBookingDetailStatus;
  readonly defaultSearchParams: any;
  readonly permissionCodeForChangePickStatus = PermissionConstants.BtnChangePickStatus;
  readonly forwarderInfoStrategyCsmCode: string = 'ForwarderInfoStrategy';
  @ViewChild('assignDate') assignDate!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;
  currentLang: string = this.laasSetting.language;
  @ViewChild('parameterGroup') parameterGroupComp!: SearchFormParameterGroupComponent;
  bookingNo: string;

  searchParams: any;
  columns: any[];
  isLoading: boolean;

  facilityOptions: any[] = [];
  bookingForwarderList: any[];
  deliveryCategoryList: any[];
  bookingTypeList: any[];
  bookingStatusOptions: any[];
  chargeStatusList: any[];
  shipTermOptions: LaasOption[];
  toCountryOptions: any[];
  toCityOptions: any[];
  assignmentDistrictIdOptions: any[];
  carSeqList: any[];
  awbAddressOptions: any[];
  letterOrgIdList: any[];
  orgIdList: any[];
  billCorpList: any[];
  shipCorpList: any[];
  areaList: any[];
  DOStatusOptions: any[];
  bookingDetailStatusOptions: any[];
  documentTypeOptions: any[];
  priorityOptions: any[];
  noPickingDoOptions: any[];
  selectedBookings: any[];
  isFeeCalculationOptions: any[];
  shipMethodOptions: any[];
  addressTypeOptions: any[];
  redeliveryBookingNoList: string[];
  bookingNoListString:string;
  frontLIneDocReferenceKeyList: string[];
  udrOptions: any[];

  facilityForwarderList: FacilityForwarder[];
  frontLineDocStatusOptions: LaasOption[] =[];

  isSearchFormOpen: boolean;

  searchResults: any[];

  detailColumns: any[];
  bookingDetails: any[];

  isShowScanDOModal: boolean;
  isShowSearchDOModal: boolean;
  isShowRtnWhRemarkModal: boolean;
  isShowRtnDeliveryRemarkModal: boolean;
  isShowUrgentRemarkModal: boolean;
  isShowSerialPdaRemarkModal: boolean;
  isShowErrorTmsModal: boolean;
  importedDOs: any[];

  importDocData: any[];
  isShowCertificateModal: boolean;
  isShowReturnTmsModal: boolean;
  isShowBookingDetailStatusChangeModal: boolean;
  isShowBillingViewerModal: boolean;
  isShowBillingPreviewCalculateViewerModal: boolean;
  isShowBookingDetailPickUpChangeModel: boolean;
  isShowRePrintDocumentBtn: boolean = false;
  isHkFacility: boolean = false;
  isShowDeliveryChooseModal: boolean = false;
  shippingMethodsForm: FormGroup;

  rowData: any;

  searchForm: FormGroup;
  itemMenus: MenuItem[];
  mainItemMenus: MenuItem[];

  // file Management
  showDoFile: boolean;
  showDoPodFile: boolean;
  bookingNoFile: string;
  bookingInfo: any;
  bookingNoPreviewCalculate: string;
  showRedeliveryBooking: boolean;

  // translate label
  transFile: any;
  transDO: any;
  transRemarks: any;
  transOriginalDoc: any;
  transUploadAttach: any;
  transTMS: any;
  transExpress: any;
  transScan: any;
  transReturnWarehouseMarks: any;
  transReDeliverRemarks: any;
  transDeliverUrgentDORemarks: any;
  transSerialPdaRemark: any;
  transDownload: any;
  transUpload: any;
  transUploadPOD: any;
  transReturnTransmitTMS: any;
  transEditExpressInfo: any;
  transReturnTransmitExpress: any;
  transFetchPod: string = '';
  containerCheckDescription: any;
  downloadExpressInvoice: any;
  transPickUpDo: any;
  transAssignBillBooking: any;
  transFrontLineDocBtnLabel: any;

  selectedDORows: any[];

  tmsData: any;
  errorTmsBookingNo: string = '';

  billCorpOptions: any[];
  isPickupFlagList: any[];

  redeliveryBookingCount: number;

  downloadMergeFileParams!: DownloadMergeFileRequset;
  @ViewChild(DataTableComponent) table!: DataTableComponent;
  @ViewChild('frontLineDoc') frontlineDoc!: FrontlineDocumentComponent;

  copyBillingBookingRequest : CopyBillBookingRequest;
  rowRedeliveryCount: number | null;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "bookingNo",
    direction: -1
  };
  transSendB2BCustom: any;
  /* 先只在前端定義狀態，如果其他頁面需要用到再共用 */
  sendB2BCustomStatusOptions: any[] = [];
  isShowControlledItemModal: boolean;
  isControlledItemList: any;
  doImportEventData: any[] = [];
  doImportOnPick: boolean = false;

  fileCategoryForTaskDoc: FileCategory = FileCategory.FrontLine;
  canEditTable: boolean = false;
  protected readonly onDropdownKeydown = onDropdownKeydown;

  canUploadDoc: boolean = false;
  canConfirm: boolean = false;
  uploadFileType: string = "";
  isShowTaskDocManagement: boolean = false;

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private dropdownOptionService: DropdownOptionsService,
    private formBuilder: FormBuilder,
    private tmsService: TmsService,
    private translate: TranslateService,
    private shippingDocumentService: ShippingDocumentService,
    private route: ActivatedRoute,
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BookingSearchForShipping;
    this.preferenceKey2 = UserPreferenceConstants.BookingSearchForShippingDetail;
    this.shippingMethodsForm = this.formBuilder.group({
      shippingMethods: this.formBuilder.array([])
    });

    this.setShippingMethods([]);

    this.defaultSearchParams = {
      facilityList: [],
      bookingForwarder: [],
      deliveryCategory: null,
      bookingType: null,
      bookingNoList: [],
      bookingStatus: [],
      carTrips: [],
      consigneeKey: [],
      chargeStatus: null, // 還沒做
      letterOrgId: [],
      orgId: [],
      billCorp: [],
      doNo: [],
      invoiceNo: [],
      createStartDt: null,
      createEndDt: null,
      assignStartDate: null,
      assignEndDate: null,
      carSeq: null,
      area: null,
      createUserList: [],
      hawbs: [],
      mawbs: [],
      isFeeCaculation: null,
      whNo: [],
      expressTerm: [],
      shipCorp: null,
      shippingMethodList: [],
      carType: null,
      mergeKey: [],
      originBookingNo: [],
      permitNo: [],
      udr: null,
      shipTerm: []
    };

    this.columns = [
      { field: 'facility', header: 'BookingSearch.MainTable.Column.Facility', sort: true },
      { field: 'bookingNo', header: 'BookingSearch.MainTable.Column.BookingNum', sort: true },
      { field: 'bookingStatus', header: 'BookingSearch.MainTable.Column.BookingStatus', sort: true },
      { field: 'bookingType', header: 'BookingSearch.MainTable.Column.Type', sort: true },
      { field: 'forwarderName', header: 'BookingSearch.MainTable.Column.Forwarder', sort: true },
      { field: 'letterHeadOrgName', header: 'BookingSearch.MainTable.Column.Company', sort: true },
      { field: 'billCorp', header: 'BookingSearch.MainTable.Column.BillComp', sort: true },
      { field: 'consigneeKey', header: 'BookingSearch.MainTable.Column.CustomerCode', sort: true },
      { field: 'consigneeCompany', header: 'BookingSearch.MainTable.Column.CustomerName', sort: true },
      { field: 'shipTerm', header: 'BookingSearch.MainTable.Column.TradeTerm', sort: true },
      { field: 'toCountry', header: 'BookingSearch.MainTable.Column.DestiCountry', sort: true },
      { field: 'toCity', header: 'BookingSearch.MainTable.Column.DestiCity', sort: true },
      { field: 'assignmentDistrictId', header: 'BookingSearch.MainTable.Column.LocalSection', sort: true },
      { field: 'carTrip', header: 'BookingSearch.MainTable.Column.CarTripNum', sort: true },
      { field: 'awbAddress', header: 'BookingSearch.MainTable.Column.PickUpLocate', sort: true },
      { field: 'assignDate', header: 'BookingSearch.MainTable.Column.AssignDate', dataType: 'date', sort: true },
      { field: 'carSeq', header: 'BookingSearch.MainTable.Column.DepartureTime', sort: true },
      { field: 'updatedTotalCaseCnt', header: 'BookingSearch.MainTable.Column.TotalCartonCnt', sort: true },
      { field: 'totalNetWeight', header: 'BookingSearch.MainTable.Column.TotalNetWeight', sort: true },
      { field: 'updatedTotalGrosswgt', header: 'BookingSearch.MainTable.Column.TotalGrossWeight', sort: true },
      { field: 'updatedTotalVolumeWeight', header: 'BookingSearch.MainTable.Column.TotalDim', sort: true },
      { field: 'estimatedCost', header: 'BookingSearch.MainTable.Column.EstimateCharges', sort: true },
      { field: 'expressBill', header: 'BookingSearch.MainTable.Column.HAWB', sort: true },
      { field: 'isPickupFlag', header: 'BookingSearch.MainTable.Column.IncludeNoPickDO', sort: true },
      { field: 'createUser', header: 'BookingSearch.MainTable.Column.Creator', sort: true },
      { field: 'createDt', header: 'BookingSearch.MainTable.Column.CreationaTime', dataType: 'date', sort: true },
      { field: 'isFeeCaculation', header: 'BookingSearch.MainTable.Column.FeeRemarks', sort: true },
      { field: 'expressTerm', header: 'BookingSearch.MainTable.Column.CourierDeliveryCondition', sort: true },
      { field: 'shipCorp', header: 'BookingSearch.MainTable.Column.ShipCorp', sort: true },
      { field: 'shippingMethod', header: 'BookingSearch.MainTable.Column.ShippingMethod', sort: true },
      { field: 'carType', header: 'BookingPreview.Form.VehicleType', sort: true },
      { field: 'addressType', header: 'BookingSearch.MainTable.Column.AddressType', sort: true },
      { field: 'mergeKey', header: 'BookingSearch.MainTable.Column.MergeKey', sort: true },
      { field: 'redeliveryCount', header: 'BookingSearch.MainTable.Column.RedeliveryCount', sort: true },
      { field: 'originBookingNo', header: 'BookingSearch.MainTable.Column.OriginBookingNo', sort: true },
      { field: 'permitNo', header: 'BookingSearch.MainTable.Column.PermitNo', sort: true },
      { field: 'inHouseNo', header: 'BookingSearch.MainTable.Column.InHouseNo', sort: true },
      { field: 'udr', header: 'BookingSearch.MainTable.Column.UDR', sort: true },
      { field: 'frontLineDocStatus', header: 'BookingSearch.MainTable.Column.FrontLineDocStatus', sort: true },
    ];

    this.detailColumns = [
      { field: '__delete', header: 'BookingSearch.SubTable.Column.Delete', sort: false },
      { field: 'facility', header: 'BookingSearch.SubTable.Column.Facility' },
      { field: 'doNo', header: 'BookingSearch.SubTable.Column.DONum' },
      { field: 'invoiceNo', header: 'BookingSearch.SubTable.Column.DOInvoiceNum' },
      { field: 'consigneeKey', header: 'BookingSearch.SubTable.Column.CustomerCode' },
      { field: 'consigneeCompany', header: 'BookingSearch.SubTable.Column.CustomerName' },
      { field: 'shipNotes', header: 'BookingSearch.SubTable.Column.Remarks' },
      { field: 'cartonCnt', header: 'BookingSearch.SubTable.Column.CartonCnt' },
      { field: 'totalGrossWeight', header: 'BookingSearch.SubTable.Column.GrossWeight' },
      { field: 'totalNetWeight', header: 'BookingSearch.SubTable.Column.NetWeight' },
      { field: 'volumeWeight', header: 'BookingSearch.SubTable.Column.Volume' },
      { field: 'doStatus', header: 'BookingSearch.SubTable.Column.DOProcessStatus' },
      { field: 'status', header: 'BookingSearch.SubTable.Column.BookingProcessStatus' },
      { field: 'orgName', header: 'BookingSearch.SubTable.Column.LoadOrderComp' },
      { field: 'shipCorpName', header: 'BookingSearch.SubTable.Column.ShipOutComp' },
      { field: 'letterHeadOrgName', header: 'BookingSearch.SubTable.Column.CompLetterHead' },
      { field: 'csr', header: 'BookingSearch.SubTable.Column.CSR' },
      { field: 'dept', header: 'BookingSearch.SubTable.Column.Department' },
      { field: 'bookingCount', header: 'BookingSearch.SubTable.Column.BookingTimes' },
      { field: 'priority', header: 'BookingSearch.SubTable.Column.DOUrgent' },
      { field: 'urgentFlag', header: 'BookingSearch.SubTable.Column.DeliveryUrgentDO' },
      { field: 'loadingDate', header: 'BookingSearch.SubTable.Column.LoadAssignTime', dataType: 'date' },
      { field: 'loadingBy', header: 'BookingSearch.SubTable.Column.LoadAssignStaffID' },
      { field: 'leaveDate', header: 'BookingSearch.SubTable.Column.LeaveDate', dataType: 'date' },
      { field: 'leaveBy', header: 'BookingSearch.SubTable.Column.LeaveBy' },
      { field: 'arrivalBy', header: 'BookingSearch.SubTable.Column.DeliveredStaffID' },
      { field: 'tmsUrl', header: 'BookingSearch.SubTable.Column.TMSURL' },
      { field: 'estimatedArrivalDt', header: 'BookingSearch.SubTable.Column.ETD', dataType: 'date' },
      { field: 'fixedEstimatedArrivalDt', header: 'BookingSearch.SubTable.Column.RevisedETD', dataType: 'date' },
      { field: 'arrivalDt', header: 'BookingSearch.SubTable.Column.ActualArrivalTime', dataType: 'date' },
      { field: 'createUser', header: 'BookingSearch.SubTable.Column.CreateBy' },
      { field: 'createDt', header: 'BookingSearch.SubTable.Column.CreationTime', dataType: 'date' },
      { field: 'updateUser', header: 'BookingSearch.SubTable.Column.UpdateBy' },
      { field: 'updateDt', header: 'BookingSearch.SubTable.Column.UpdateTime', dataType: 'date' },
      { field: 'rebookingRemark', header: 'BookingSearch.SubTable.Column.ReasonMultiDeliver' },
      { field: 'noPickingDo', header: 'BookingSearch.SubTable.Column.DONoPicking' },
      { field: 'whNo', header: 'BookingSearch.SubTable.Column.WhNo' },
      { field: 'sendB2BCustomStatus', header: 'BookingSearch.SubTable.Column.SendB2BCustomStatus' },
      { field: 'sendB2BCustomMsg', header: 'BookingSearch.SubTable.Column.SendB2BCustomMsg' },
      { field: 'stoNo', header: 'BookingSearch.SubTable.Column.StoNo' },
      { field: 'dnNo', header: 'BookingSearch.SubTable.Column.DnNo' },
    ];

    this.searchParams = deepCopy(this.defaultSearchParams);

    this.searchForm = this.formBuilder.group({
      facilityList: [],
      bookingForwarder: [],
      deliveryCategory: null,
      bookingType: null,
      bookingNoList: [],
      bookingStatus: [],
      carTrips: [],
      consigneeKey: [],
      chargeStatus: null, // 還沒做
      letterOrgId: [],
      orgId: [],
      billCorp: [],
      doNo: [],
      invoiceNo: [],
      createStartDt: null,
      createEndDt: null,
      assignStartDate: null,
      assignEndDate: null,
      carSeq: null,
      area: null,
      createUserList: [],
      hawbs: [],
      mawbs: [],
      isFeeCaculation: null,
      whNo: [],
      expressTerm: [],
      shipCorp: null,
      shippingMethodList: [],
      carType: null,
      mergeKey: [],
      originBookingNo: [],
      permitNo: [],
      udr: null,
      shipTerm: [],
      frontLineDocStatus: null,
    });

    this.isLoading = false;
    this.bookingStatusOptions = [];
    this.DOStatusOptions = [];
    this.bookingDetailStatusOptions = [];
    this.bookingForwarderList = [];
    this.deliveryCategoryList = [];
    this.bookingTypeList = [];
    this.selectedBookings = [];
    this.chargeStatusList = [];
    this.shipTermOptions = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.assignmentDistrictIdOptions = [];
    this.carSeqList = [];
    this.awbAddressOptions = [];
    this.letterOrgIdList = [];
    this.orgIdList = [];
    this.billCorpList = [];
    this.shipCorpList = [];
    this.areaList = [];
    this.isFeeCalculationOptions = [];
    this.shipMethodOptions = [];
    this.priorityOptions = [];
    this.noPickingDoOptions = [
      { label: '揀貨', value: '0' },
      { label: '不揀貨', value: '1' }
    ];
    this.documentTypeOptions = [];
    this.isSearchFormOpen = true;
    this.searchResults = [];
    this.isShowScanDOModal = false;
    this.isShowSearchDOModal = false;
    this.isShowRtnWhRemarkModal = false;
    this.isShowRtnDeliveryRemarkModal = false;
    this.isShowUrgentRemarkModal = false;
    this.isShowSerialPdaRemarkModal = false;
    this.isShowCertificateModal = false;
    this.isShowReturnTmsModal = false;
    this.isShowBookingDetailStatusChangeModal = false;
    this.isShowBillingViewerModal = false;
    this.isShowErrorTmsModal = false;
    this.isShowBillingPreviewCalculateViewerModal = false;
    this.isShowBookingDetailPickUpChangeModel = false;
    this.importedDOs = [];
    this.bookingNo = '';
    this.bookingDetails = [];
    this.importDocData = [];
    // translate
    this.mainItemMenus = [];
    this.itemMenus = [];
    this.frontLIneDocReferenceKeyList = [];
    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();
    this.billCorpOptions = [];

    this.showDoFile = false;
    this.showDoPodFile = false;
    this.bookingNoFile = '';

    this.selectedDORows = [];

    this.selectedDORows = [];
    this.tmsData = [];

    // file management
    this.showDoFile = false;
    this.showDoPodFile = false;
    this.bookingNoFile = '';
    this.bookingNoPreviewCalculate = '';

    this.isPickupFlagList = [
      { value: 0, label: '全揀貨' },
      { value: 1, label: '含不揀貨' }
    ];
    this.addressTypeOptions = [];
    this.showRedeliveryBooking = false;
    this.redeliveryBookingNoList = [];
    this.bookingNoListString = '';
    this.redeliveryBookingCount = 0;
    this.copyBillingBookingRequest = {
      facility: this.laasSetting.facility,
      doNoList: [],
      createUser: '',
      originBookingNo: null,
      redeliveryCount: 1,
      successFlag: false,
      newBooking: null,
      originBookingForwarder: null
    };
    this.rowRedeliveryCount = 0;
    this.isShowControlledItemModal = false;
    this.udrOptions = [];
    this.facilityForwarderList = [];
  }

  get shippingMethods() {
    return this.shippingMethodsForm.get('shippingMethods') as FormArray;
  }

  setShippingMethods(methods: { shippingMethod: string }[]) {
    const shippingMethodsFGs = methods.map(method => this.formBuilder.group(method));
    const shippingMethodsFormArray = this.formBuilder.array(shippingMethodsFGs);
    this.shippingMethodsForm.setControl('shippingMethods', shippingMethodsFormArray);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getAppCsmSetting('HKFacilitySetting').subscribe({
      next:(option:any)=>{
        this.isHkFacility = option.appCsmSettingDetailList.some((item: { setupValue: string }) =>
          item.setupValue === this.laasSetting.facility
        );
      }
    });

    this.isShowRePrintDocumentBtn = this.permissionCodes.includes(PermissionConstants.BtnRePrintDocument);

    this.searchParams.facilityList = this.userProfile.userType === UserType.SuperAdmin.toString() || this.userProfile.userType === UserType.Tenant.toString() ? null : [this.laasSetting.facility];
    this.defaultSearchParams.facilityList = deepCopy(this.searchParams.facilityList);

    const routeData = this.routeStateService.getCurrentAndConsume()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.searchParams.bookingNoList = routeData.bookingNoList;
      if (routeData.errMsgs != null && routeData.errMsgs.length > 0) {
        const msgs = routeData.errMsgs.reduce(
          (str: string, msg: string, idx: number) => {
            str += `${idx + 1}. ${msg}\n`;
            return str;
          }, '');
        this.toastService.error(msgs);
      } else {
        this.searchBtnClick();
      }
    }

    let hawbNos = this.confirmQueryParamsAndPerformAutomaticQuery();
    let hawbNoList: string[] = [];
    if (!isNullOrEmpty(hawbNos)) {
      hawbNoList.push(hawbNos);
      console.log(hawbNoList);
      this.searchParams.hawbs = hawbNos;
      this.searchBtnClick();
    }

    this.route.queryParams.subscribe((params: Params) => {
      this.route.queryParams.subscribe((params: Params) => {
        const paramsKeys = Object.keys(params);
        const needParams = ['doNo', 'bookingNo'];
        if (!needParams.some((key) => paramsKeys.includes(key))) {
          return;
        }
        if (params['doNo']) {
          const parseDoNo = params['doNo'].split(';').filter((doNo: any) => !isNullOrEmpty(doNo));
          if (parseDoNo.length > 0) {
            this.searchForm.controls["doNo"].setValue(parseDoNo);
            return this.searchBtnClick();
          }
        }
        if (params['bookingNo']) {
          const parseBookingNo = params['bookingNo'].split(';').filter((bookingNo: any) => !isNullOrEmpty(bookingNo));
          if (parseBookingNo.length > 0) {
            this.searchForm.controls["bookingNoList"].setValue(parseBookingNo);
            return this.searchBtnClick();
          }
        }
      });
    });

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.filter(x => {
          return this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(null) ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode)
        })
        .map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result) => {
        this.bookingForwarderList = result;
      }
    });

    this.dropdownOptionService.getCarSeqOptions().subscribe({
      next: (result) => {
        this.carSeqList = result;
      }
    });

    this.dropdownOptionService.getLetterOrgOptions().subscribe({
      next: (result: any[]) => {
        this.letterOrgIdList =
          this.orgIdList =
          this.shipCorpList =
            result.map((x) => ({
              label: x.legalEntityOUName,
              value: x.legalEntityOUCode,
            }));
        this.billCorpList = result
          .filter((x) => x.billOUCode !== null)
          .reduce((options, item) => {
            if (
              options.findIndex((x: any) => x.value === item.billOUCode) < 0
            ) {
              options.push({ label: item.billOUName, value: item.billOUCode });
            }
            return options;
          }, [])
          .sort((a: any, b: any) => {
            return a.value > b.value ? 1 : -1;
          });
      },
    });

    this.dropdownOptionService.getAreaOptions().subscribe({
      next: (options: any[]) => {
        this.areaList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryCategoryList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingTypeOptions().subscribe({
      next: (options: any[]) => {
        this.bookingTypeList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.shipTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.toCityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    this.dropdownOptionService.getAreaOptions().subscribe({
      next: (options: any[]) => {
        this.assignmentDistrictIdOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPickupLocationOptions().subscribe({
      next: (options: any[]) => {
        this.awbAddressOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDOStatusOptions().subscribe({
      next: (options: any[]) => {
        this.DOStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingDetailStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingDetailStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPriorityOptions().subscribe({
      next: (options: any[]) => {
        this.priorityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'BookingQueryChargesStatus'
      )
      .subscribe({
        next: (options: any[]) => {
          this.chargeStatusList = options.map((x) => ({
            label: x.codeKey + '-' + x.codeDesc,
            value: x.codeKey,
          }));
        },
      });

    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map((x) => ({
          label: `${x.optionCode}-${x.optionDesc}`,
          value: x.optionCode,
        }));
      },
    });

    /**
     * Main table 下拉式按鈕選單 (p-menubar)
     */
    this.dropdownOptionService
      .getDocumentTypeOptionsByCategories([2, 3])
      .subscribe({
        next: (options: any[]) => {
          if (!this.permissionCodes.includes(PermissionConstants.ViewShipImportConfirmReportForBooking)) {
            const index = options.findIndex((x) => x.optionCode === 'ShipImportConfirmForBooking');
            options.splice(index, 1);
          }

          this.mainItemMenus = [
            {
              label: this.transFile,
              items: [],
            },
          ];

          const menuItems = options.map((x) => {
            return {
              label: x.optionDesc,
              state: {
                docType: x.optionCode,
                isAllowRemovePrinted: x.isAllowRemovePrinted,
              },
              command: (event: any) => {
                const docType = event.item.state.docType;
                const bookings = this.selectedBookings.map((x: any) => {
                  return x.bookingNo;
                });

                let isAllowRemovePrinted = event.item.state.isAllowRemovePrinted == 1;
                if (isAllowRemovePrinted) {
                  // 是否排除列印過的文件?
                  this.translateService
                    .get('BoookingSearch.Confirm.ExcludePrintedDoc')
                    .subscribe({
                      next: (excludePrintedDoc) => {
                        // 確定排除
                        this.translateService
                          .get('BoookingSearch.Confirm.ConfirmExclude')
                          .subscribe({
                            next: (confirmExclude) => {
                              this.confirmationService.confirm({
                                message: excludePrintedDoc,
                                header: confirmExclude,
                                rejectVisible: true,
                                accept: () => {
                                  this.downloadShippingDocuments(
                                    docType,
                                    'Booking',
                                    bookings,
                                    isAllowRemovePrinted,
                                    ''
                                  );
                                },
                                reject: (type: ConfirmEventType) => {
                                  switch (type) {
                                    case ConfirmEventType.REJECT:
                                      isAllowRemovePrinted = false;
                                      this.downloadShippingDocuments(
                                        docType,
                                        'Booking',
                                        bookings,
                                        isAllowRemovePrinted,
                                        ''
                                      );
                                      break;
                                    case ConfirmEventType.CANCEL:
                                      this.confirmationService.close();
                                      break;
                                  }
                                },
                              });
                            },
                          });
                      },
                    });
                } else {
                  if (docType === 'ProofOfDelivery') {
                    this.downloadMergeFile([docType], bookings);
                  } else {
                    this.downloadShippingDocuments(
                      docType,
                      'Booking',
                      bookings,
                      isAllowRemovePrinted,
                      ''
                    );
                  }
                }
              },
            };
          });
          menuItems.unshift(
            {
              label: this.transFrontLineDocBtnLabel,
              state: {
                docType: null,
                isAllowRemovePrinted: null,
              },
              command: (event: any) => {
                if (this.selectedBookings.length == 0) {
                  return
                }
                this.frontlineDocBtnClick()
              },
            }
          );

          this.mainItemMenus[0].items = menuItems;
        },
      });


    // permission Codes
    let userPermissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    /**
     * Row expansion 下拉式按鈕選單 (p-menubar)
     */
    this.dropdownOptionService
      .getDocumentTypeOptionsByCategories([1, 3])
      .subscribe({
        next: (options: any[]) => {
          this.itemMenus = [
            {
              label: this.transDO,
              items: [
                {
                  label: this.transScan,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.scanDOBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransDoScan
                  ),
                },
                {
                  label: this.transDO, // DO 單號查詢匯入
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.searchDOBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransDoImport
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnTransDoScan ||
                  x === PermissionConstants.BtnTransDoImport
              ),
            },
            {
              label: this.transRemarks,
              items: [
                {
                  label: this.transReturnWarehouseMarks,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.rtnWarehouseBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) => x === PermissionConstants.BtnRewarehouse
                  ),
                },
                {
                  label: this.transReDeliverRemarks,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.rtnDeliveryBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) => x === PermissionConstants.BtnRedelivery
                  ),
                },
                {
                  label: this.transDeliverUrgentDORemarks,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.urgentBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) => x === PermissionConstants.BtnUrgentFlag
                  ),
                },
                {
                  label: this.transSerialPdaRemark,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.serialPdaBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.EditBookingDetailSerialPda
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnRewarehouse ||
                  x === PermissionConstants.BtnRedelivery ||
                  x === PermissionConstants.BtnUrgentFlag ||
                  x === PermissionConstants.EditBookingDetailSerialPda
              ),
            },
            {
              label: this.transOriginalDoc,
              items: [
                {
                  label: this.transDownload,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.certificateBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransOriginalDocDownload
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnTransOriginalDocDownload
              ),
            },
            {
              label: this.transUploadAttach,
              items: [
                {
                  label: this.transUpload,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.bookingNoFile = rowData.bookingNo;
                    this.showDoFile = true;
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransAttachUpload
                  ),
                },
                {
                  label: this.transUploadPOD,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.bookingNoFile = rowData.bookingNo;
                    this.showDoPodFile = true;
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransAttachUploadPOD
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnTransAttachUpload ||
                  x === PermissionConstants.BtnTransAttachUploadPOD
              ),
            },
            {
              label: this.transTMS,
              items: [
                {
                  label: this.transReturnTransmitTMS,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.returnTmsBtnClick(event, rowData);
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransTMSReturnTransmitTMS
                  ),
                },
                {
                  label: '收取異常TMS',
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.errorTmsBookingNo = rowData.bookingNo;

                    this.tmsService
                      .getTMSErrorLog(this.errorTmsBookingNo)
                      .subscribe({
                        next: (result) => {
                          if (result.length > 0) {
                            this.isShowErrorTmsModal = true;
                          } else {
                            this.toastService.info('此Booking下目前無異常TMS');
                          }
                        },
                      });
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransTMSErrorTMS
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnTransTMSReturnTransmitTMS ||
                  x === PermissionConstants.BtnTransTMSErrorTMS
              ),
            },
            {
              label: this.transExpress,
              items: [
                {
                  label: this.transEditExpressInfo,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }

                    const facility = rowData.facility;
                    const bookingNo = rowData.bookingNo;
                    const bookingForwarder = rowData.bookingForwarder;

                    const findForwarderInfoStrategy = this.facilityForwarderList.find(
                      (x) => x.forwarderCode === bookingForwarder && x.isExpress === 1
                    );

                    if (!findForwarderInfoStrategy) {
                      this.toastService.warn('此貨代沒有快遞資訊');
                      return;
                    }

                    const isForwarderDhl = findForwarderInfoStrategy.forwarderNameAlias.toUpperCase().includes('DHL');
                    const observExpress = isForwarderDhl ? this.bookingService.getDHLInfo(facility, bookingNo) : this.bookingService.getForwarderInfo(facility, bookingNo);
                    const navigateToUrl = isForwarderDhl ? '/TransportOperation/DHLEdit' : '/TransportOperation/ForwarderInfoEdit';
                    observExpress.subscribe({
                      next: () => {
                        this.routeStateService.navigateTo(
                          navigateToUrl,
                          {
                            facility: facility,
                            bookingNo: bookingNo,
                            bookingForwarder: bookingForwarder,
                          },
                          true
                        );
                      },
                      error: (err) => {
                        this.toastErrorMessage(err.error);
                      },
                      complete: () => {},
                    });
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransDHLEditDHLInfo
                  ),
                },
                {
                  label: this.transReturnTransmitExpress,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    const facility = rowData.facility;
                    const bookingNo = rowData.bookingNo;
                    const bookingForwarder = rowData.bookingForwarder;

                    const findForwarderInfoStrategy = this.facilityForwarderList.find(
                      (x) => x.forwarderCode === bookingForwarder && x.isExpress === 1
                    );

                    if (!findForwarderInfoStrategy) {
                      this.toastService.warn('此貨代沒有快遞資訊');
                      return;
                    }

                    const isForwarderDhl = findForwarderInfoStrategy.forwarderNameAlias.toUpperCase().includes('DHL');
                    const observExpressCheck = isForwarderDhl ? this.bookingService.dhlReturnCheck(bookingNo, facility) : this.bookingService.getForwarderInfo(facility, bookingNo);
                    const sendForwarderWayBill = isForwarderDhl ? this.sendDHLWayBill.bind(this) : this.sendForwarderWayBill.bind(this);
                    combineLatest([
                      observExpressCheck,
                      this.translateService.get('BoookingSearch.Confirm.Resend'),
                      this.translateService.get('BoookingSearch.Confirm.Running'),
                    ]).subscribe({
                      next: ([result, resendMessage, runningMessage]) => {
                        if (result.status == 'I') {
                          return sendForwarderWayBill(
                            bookingNo,
                            bookingForwarder,
                            facility
                          );
                        }
                        let message = resendMessage;
                        if (result.status == 'P') {
                          message = runningMessage;
                        }
                        // 已成功傳送過，是否要重新回傳?
                        this.confirmationService.confirm({
                          target: event.target,
                          message,
                          icon: 'pi pi-exclamation-triangle',
                          accept: () => {
                            sendForwarderWayBill(
                              bookingNo,
                              bookingForwarder,
                              facility
                            );
                          }
                        });
                      },
                      error: (err) => {
                        this.toastErrorMessage(err.error);
                      },
                      complete: () => {},
                    });
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransDHLReturnTransmitDHL
                  ),
                },
                {
                  label: this.downloadExpressInvoice,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) return;
                    const downloadInvoiceReq = new downloadExpressInvoiceRequest();
                    console.log(rowData.bookingNo);
                    downloadInvoiceReq.bookingNo = rowData.bookingNo;

                    if (this.checkIsDHLExpress()) {
                      this.downloadDHLInvoiceFile(downloadInvoiceReq)
                    } else {
                      this.downloadForwarderInvoiceFile(downloadInvoiceReq)
                    }
                  },
                  visible: userPermissionCodes.some(
                    (x: string) =>
                      x === PermissionConstants.BtnTransDHLDownloadDHLInvoice
                  ),
                },
                {
                  label: this.transFetchPod,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    const forwarderFetchFedExPodByFacilityAndBookingNoRequest = new ForwarderFetchFedExPodByFacilityAndBookingNoRequest();
                    forwarderFetchFedExPodByFacilityAndBookingNoRequest.facility = rowData.facility;
                    forwarderFetchFedExPodByFacilityAndBookingNoRequest.bookingNo = rowData.bookingNo;
                    this.bookingService
                      .forwarderFetchFedExPodByFacilityAndBookingNo(
                        forwarderFetchFedExPodByFacilityAndBookingNoRequest
                      )
                      .subscribe({
                        next: () => {
                          this.translateService
                            .get('BoookingSearch.Success.Uploadsuccess')
                            .subscribe((msg: string) => {
                              this.toastService.success(msg);
                            });
                        },
                        error: (err) => {
                          this.toastErrorMessage(err.error);
                        },
                      });
                  }
                }
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnTransDHLEditDHLInfo ||
                  x === PermissionConstants.BtnTransDHLReturnTransmitDHL ||
                  x === PermissionConstants.BtnTransDHLDownloadDHLInvoice
              ),
            },
            {
              label: '費用',
              items: [
                {
                  label: '檢視',
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.bookingInfo = rowData;
                    this.bookingNoFile = rowData.bookingNo;
                    this.isShowBillingViewerModal = true;
                  },
                  visible: userPermissionCodes.some(
                    (x: string) => x === PermissionConstants.BtnExpenseView
                  ),
                },
                {
                  label: '產生報價',
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    if (isNullOrEmpty(rowData.incoTerm) && rowData.deliveryType.toUpperCase() == "EXPORT"){
                      this.toastService.warn('Export單且貿易條件無資訊，無法產生報價');
                    }else if (
                      (isNaN(Number(rowData.bookingStatus)) &&
                        rowData.bookingStatus.toUpperCase() != 'C') ||
                      Number(rowData.bookingStatus) >= 2
                    ) {
                      if (isNullOrEmpty(rowData.redeliveryCount)) {
                        this.rowRedeliveryCount = 0;
                      } else {
                        this.rowRedeliveryCount = rowData.redeliveryCount;
                      }
                      console.log(this.rowRedeliveryCount);
                      this.isShowBillingPreviewCalculateViewerModal = true;
                      this.bookingNoPreviewCalculate = rowData.bookingNo;
                    } else {
                      this.toastService.info('此Booking目前狀態下無法產生報價');
                    }
                  },
                  visible: userPermissionCodes.some(
                    (x: string) => x === PermissionConstants.BtnExpenseApply
                  ),
                },
              ],
              visible: userPermissionCodes.some(
                (x: string) =>
                  x === PermissionConstants.BtnExpenseView ||
                  x === PermissionConstants.BtnExpenseApply
              ),
            },
          ];

          this.itemMenus.forEach((x) => {
            if (x.items?.every((y) => y.visible === false)) {
              x.visible = false;
            }
          });

          const menuItems = options.map((x) => {
            const menu = {
              label: x.optionDesc,
              state: { docType: x.optionCode },
              command: (event: any) => {
                const rowData = this.table.selectedRow;
                if (!rowData) {
                  return;
                }
                const docType = event.item.state.docType;

                let doNos = rowData.doNos.map((x: any) => {
                  return x.doNo;
                });
                let remark = rowData.bookingNo;
                this.downloadShippingDocuments(
                  docType,
                  'DeliveryOrder',
                  doNos,
                  false,
                  remark
                );
              },
            };
            return menu;
          });

          let rootMenu: MenuItem = {
            label: this.transFile,
            items: menuItems,
          };
          this.itemMenus.push(rootMenu);

          const canChangeBookingDetailStatus = this.permissionCodes.includes(
            this.permissionCodeForChangeBookingDetailStatus
          );

          const canChangePickStatus = this.permissionCodes.includes(
            this.permissionCodeForChangePickStatus
          );

          if (canChangeBookingDetailStatus || canChangePickStatus) {
              const menu = {
                label: '更新狀態選單',
                items: [
                  {
                    label: '狀態更新',
                    command: (event: any) => {
                      const rowIdx = parseInt(
                        event.originalEvent.currentTarget
                          .closest('tr')
                          ?.getAttribute('rowIndex'),
                        10
                      );
                      if (Number.isInteger(rowIdx) === false) {
                        return;
                      }
                      const rowData = this.searchResults[rowIdx];
                      this.bookingDetailStatusChangeModal(event, rowData);
                    },
                    visible: canChangeBookingDetailStatus
                  },
                  {
                    label: this.transPickUpDo,

                    command: (event: any) => {
                      const rowIdx = parseInt(
                        event.originalEvent.currentTarget
                          .closest('tr')
                          ?.getAttribute('rowIndex'),
                        10
                      );
                      if (Number.isInteger(rowIdx) === false) {
                        return;
                      }
                      const rowData = this.searchResults[rowIdx];
                      this.pickUpDoBtnClick(event, rowData);
                    },
                    visible: canChangePickStatus
                  },
                ]

              };

              this.itemMenus.push(menu);
          }

          let copyBillBookingMenuItem: MenuItem = {
            label: this.transAssignBillBooking,
            command: (event: any) => {
              const rowIdx = parseInt(
                event.originalEvent.currentTarget
                  .closest('tr')
                  ?.getAttribute('rowIndex'),
                10
              );
              if (Number.isInteger(rowIdx) === false) {
                return;
              }
              const rowData = this.searchResults[rowIdx];
              if (!rowData.doNos || rowData.doNos.length === 0) {
                this.toastService.warn(this.translateService.instant(
                  'BookingSearch.Message.ChooseBookingDetail'
                ));
                return;
              }
              this.copyBillBooking(event, rowData);
            }
          };
          this.itemMenus.push(copyBillBookingMenuItem);

          const sendB2BCustomMenuItem: MenuItem = {
            label: this.transSendB2BCustom,
            command: () => {
              const rowData = this.table.selectedRow;
              if (!rowData) {
                return;
              }
              /* 取得被選取的DO單號 */
              const { bookingNo, bookingForwarder: forwarder, doNos }: { bookingNo: string, orgId: string, bookingForwarder: string, doNos: any[] } = rowData;
              if (!doNos.length) {
                this.toastService.warn(this.translateService.instant(
                  'BookingSearch.Message.ChooseBookingDetail'
                ));
                return;
              }
              const sendB2BCustomRequests = doNos.map(({ doNo, shipCorp }) => ({
                doNo,
                orgId: shipCorp,
                forwarder,
                bookingNo,
                sendB2BStatus: 'S',
                userName: this.userProfile.userName,
              }));
              sendB2BCustomRequests.forEach((request) => {
                this.bookingService.sendB2BCustom(request).subscribe({
                  next: (result) => {
                    this.toastService.success(this.translateService.instant('Common.TMS.Success'));
                  },
                  error: (err) => {
                    this.toastErrorMessage(err.error);
                  },
                });
              });
              this.searchDetailClick({ rowData, expanded: false });
            },
            visible: true,
          };
          this.itemMenus.push(sendB2BCustomMenuItem);
        },
      });

    this.dropdownOptionService
      .getLetterOrgOptions(this.laasSetting.facility)
      .subscribe({
        next: (options: any[]) => {
          this.billCorpOptions = options.map((x) => ({
            label: x.billOUName,
            value: x.billOUCode,
          }));
        },
      });

    // rbac to maintain this page
    let canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'IsFeeCalculation'
      )
      .subscribe({
        next: (options: any[]) => {
          this.isFeeCalculationOptions = options.map((x) => ({
            label: x.codeDesc,
            value: x.codeKey,
          }));
        },
      });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'AddressCategoryOptions'
      )
      .subscribe({
        next: (options: any[]) => {
          this.addressTypeOptions = options.map((x) => ({
            label: x.codeDesc,
            value: x.codeKey,
          }));
        },
      });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'AutoSendB2BStatus'
      )
      .subscribe({
        next: (options: any[]) => {
          this.sendB2BCustomStatusOptions = options.map((x) => ({
            label: x.codeDesc,
            value: x.codeKey,
          }));
        },
      });

    this.facilityService.getFacilityForwarder().subscribe({
      next: (result) => {
        this.facilityForwarderList = result;
      }
    });

    if (this.laasSetting.facility == 'en-us') {
      this.udrOptions = [
        { value: 'Y', label: 'exist' },
        { value: 'N', label: 'not exist' }
      ];
    } else {
      this.udrOptions = [
        { value: 'Y', label: '是' },
        { value: 'N', label: '否' }
      ];
    }

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FrontLineDocStatus").subscribe({
          next: (options: CodeConverterOptions[]) => {
            this.frontLineDocStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
          }
        });
  }

  // translate word
  translationLabel() {
    // 下載文件
    this.transFile = this.translateService.instant(
      'BookingSearch.SubTable.Button.DownloadFile'
    );
    // DO 單號匯入
    this.transDO = this.translateService.instant(
      'BookingSearch.SubTable.Button.DONumImport'
    );
    // 註記
    this.transRemarks = this.translateService.instant(
      'BookingSearch.SubTable.Button.Remarks'
    );
    // 原始憑證
    this.transOriginalDoc = this.translateService.instant(
      'BookingSearch.SubTable.Button.OriginalDoc'
    );
    // 附件上傳
    this.transUploadAttach = this.translateService.instant(
      'BookingSearch.SubTable.Button.UploadAttach'
    );
    // TMS
    this.transTMS = this.translateService.instant(
      'BookingSearch.SubTable.Button.TMS'
    );
    // DHL -> 名稱改為快遞 Express
    this.transExpress = this.translateService.instant(
      'BookingSearch.SubTable.Button.Express'
    );
    // DO 單號掃描
    this.transScan = this.translateService.instant(
      'BookingSearch.SubTable.Button.DONumScan'
    );
    // 回倉註記
    this.transReturnWarehouseMarks = this.translateService.instant(
      'BookingSearch.SubTable.Button.ReturnWarehouseMarks'
    );
    // 重送註記
    this.transReDeliverRemarks = this.translateService.instant(
      'BookingSearch.SubTable.Button.ReDeliverRemarks'
    );
    // 運輸急單註記
    this.transDeliverUrgentDORemarks = this.translateService.instant(
      'BookingSearch.SubTable.Button.DeliverUrgentDORemarks'
    );
    // 送貨序號註記
    this.transSerialPdaRemark = this.translateService.instant(
      'BookingSearch.SubTable.Button.transSerialPdaRemark'
    );
    // 下載
    this.transDownload = this.translateService.instant(
      'BookingSearch.SubTable.Button.Download'
    );
    // 上傳
    this.transUpload = this.translateService.instant(
      'BookingSearch.SubTable.Button.Upload'
    );
    // 客戶簽收單上傳
    this.transUploadPOD = this.translateService.instant(
      'BookingSearch.SubTable.Button.UploadPOD'
    );
    // 回傳TMS
    this.transReturnTransmitTMS = this.translateService.instant(
      'BookingSearch.SubTable.Button.ReturnTransmitTMS'
    );
    // 修改快遞資訊
    this.transEditExpressInfo = this.translateService.instant(
      'BookingSearch.SubTable.Button.EditExpressInfo'
    );
    // 回傳快遞
    this.transReturnTransmitExpress = this.translateService.instant(
      'BookingSearch.SubTable.Button.ReturnTransmitExpress'
    );
    // 手動抓取POD
    this.transFetchPod = this.translateService.instant(
      'BookingSearch.SubTable.Button.FetchPod'
    );
    // Container Check Description
    this.containerCheckDescription = this.translateService.instant(
      'BookingSearch.Confirm.ContainerCheck'
    );
    this.downloadExpressInvoice = this.translateService.instant(
      'BookingSearch.SubTable.Button.DownloadExpressInvoice'
    );
    this.transPickUpDo = this.translateService.instant(
      'BookingSearch.SubTable.Button.UpdatePickUpStatus'
    );
    // 指派費用Booking
    this.transAssignBillBooking = this.translateService.instant(
      'BookingSearch.SubTable.Button.AssignBillBooking'
    );
    // 傳送B2B按鈕
    this.transSendB2BCustom = this.translateService.instant(
      'BookingSearch.SubTable.Button.SendB2BCustom'
    );
    this.transFrontLineDocBtnLabel = this.translateService.instant(
      'ShippingStatus.Button.FrontLineDoc'
    );
  }

  bookingAccordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.table.setCurrentPage(0);
    this.searchBooking();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBooking();
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.selectedBookings.length = 0;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.searchBooking();
  }

  searchBooking(): void {
    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
    params.orgIds = this.searchParams.orgId;
    params.bookingForwarders = this.searchParams.bookingForwarder;
    params.bookingNos = this.searchParams.bookingNoList;
    params.consigneeKeys = this.searchParams.consigneeKey;
    params.letterOrgIds = this.searchParams.letterOrgId;
    params.billCorps = this.searchParams.billCorp;
    params.shipCorps = this.searchParams.shipCorp;
    params.doNos = this.searchParams.doNo;
    params.whNos = this.searchParams.whNo;
    params.invoiceNos = this.searchParams.invoiceNo;
    params.shippingMethods = this.searchParams.shippingMethodList;
    params.createStartDt = isNullOrEmpty(params.createStartDt) ? null : new Date(params.createStartDt).toISOString();
    params.createEndDt = isNullOrEmpty(params.createEndDt) ? null : new Date(params.createEndDt).toISOString();
    params.assignStartDate = isNullOrEmpty(params.assignStartDate) ? null : new Date(params.assignStartDate).toISOString();
    params.assignEndDate = isNullOrEmpty(params.assignEndDate) ? null : new Date(params.assignEndDate).toISOString();
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    params.mergeKey = this.searchParams.mergeKey;
    params.originBookingNo = this.searchParams.originBookingNo;
    params.permitNo = this.searchParams.permitNo;
    params.udr = this.searchParams.udr;
    params.shipTerm = this.searchParams.shipTerm;
    params.frontLineDocStatus = this.searchParams.frontLineDocStatus;

    this.isLoading = true;
    this.bookingService.getBookingHeader(params)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (response) => {
          response.content.forEach((x: any) => {
            x.bookingDetails = [];
          });
          this.searchResults = response.content;
          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
          this.table.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (err: HttpErrorResponse) => {
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        },
      });
  }

  bookingNoLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/BookingHeaderDetail',
      rowData,
      true
    );
  }

  scanDOBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowScanDOModal = true;
  }

  searchDOBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowSearchDOModal = true;
  }

  rtnWarehouseBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowRtnWhRemarkModal = true;
  }

  rtnDeliveryBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowRtnDeliveryRemarkModal = true;
  }

  urgentBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowUrgentRemarkModal = true;
  }

  serialPdaBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowSerialPdaRemarkModal = true;
  }

  remarkSaved(event: any, booking: any, headerSearchFlag: boolean): void {
    console.log(event);
    if (headerSearchFlag) {
      this.searchBtnClick();
    }
    this.searchDetailClick({ rowData: booking, expanded: false });
    this.translateService.get('Common.Message.SuccessSave').subscribe({
      next: (msg) => {
        this.toastService.success(msg);
      },
    });
  }

  checkRemarKAndCartonCn(dos: any): boolean {
    let isOk = true;

    const dropDos = dos.filter((x: any) => {
      return x.isDropRemark && x.cartonCnt == null;
    });

    if (dropDos.length > 0) {
      // 請維護下列出貨單的箱數
      this.translateService
        .get('BoookingSearch.Alert.PleaseMaintainNum')
        .subscribe({
          next: (result) => {
            let msg = `${result}：\n`;
            dropDos.forEach((x: any, index: number) => {
              msg += `${index + 1}. ${x.doNo} \n`;
            });
            this.toastService.warn(msg, true);

            isOk = false;
          },
        });
    }

    return isOk;
  }

  private isDropDo(d: any): boolean {
    return d.isDropRemark == 1 && d.dropType == 'O';
  }

  private isDropDos(dos: any[]): boolean {
    return dos.every(d => this.isDropDo(d));
  }

  private handleDOModalImported(): void {
    const Dos = this.doImportEventData;
    const onPick = this.doImportOnPick;
    const rowData = this.rowData;
    const DONos = Dos.map((x: any) => x.doNo);
    const isDrop = this.isDropDos(Dos);

    // 如果是 空非強制不撿貨，剩下靠判斷
    Dos.forEach((x: any) => {
      x.noPickingDo = this.isDropDo(x) ? '1' : onPick;
    });


    console.log('handleDOModalImported Dos:', Dos);

    this.importedDOs = [];
    this.isShowScanDOModal = false;
    this.isShowSearchDOModal = false;

    let isPaas = this.checkRemarKAndCartonCn(this.importedDOs);
    if (!isPaas) {
      return;
    }

    if (
      ['C'].includes(rowData.bookingStatus) ||
      (['2','5'].includes(rowData.bookingStatus) && !isDrop)
    ) {
      // 此 Booking 狀態不可加單
      this.translateService.get('BoookingSearch.Alert.CannotAddDO').subscribe({
        next: (result) => {
          this.toastService.warn(result);
        },
      });
      return;
    }

    this.bookingService
      .checkBookingDetailsInserable(this.bookingNo, DONos)
      .subscribe({
        next: (result) => {
          const invalidDONos: string[] = result.validationList
            .filter((x: any) => !x.validationFlag)
            .map((x: any) => x.doNo);

          const validDONos: string[] = result.validationList
            .filter((x: any) => x.validationFlag)
            .map((x: any) => x.doNo);

          const validDOs = Dos.filter((x: any) =>
            validDONos.includes(x.doNo)
          );

          this.importedDOs = [...this.importedDOs, ...validDOs];
          if (validDOs.length > 0) {
            this.saveDoNoIntoBooking(this.bookingNo, this.importedDOs);
          }

          if (invalidDONos.length > 0) {
            this.translateService.get('BoookingSearch.Alert.InvalidDOs').subscribe({
              next: (result) => {
                this.toastService.warn(`${result}: ${invalidDONos.join(', ')}`);
              },
            });
          }
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  DOScanModalImported(event: any): void {
    this.doImportEventData = event.data;
    this.doImportOnPick = event.isActive;
    this.bookingService.isControlledItem(this.doImportEventData, this.laasSetting.facility)
      .subscribe({
        next: result => {
          this.loader.hide();
          this.isControlledItemList = result.checkLicenseNoList;
          var respFlag = result.flag;
          var respMsg = result.message;

          if (respFlag == "SG_ERP_ERROR") {
            //ERP回傳管制料號憑證錯誤
            this.translateService.get('CreateBooking.Alert.ERPError')
              .subscribe({
                next: result => {
                  this.toastService.warn(result + respMsg);
                }
              });
          } else if (respFlag == "SG_STATUS_ERROR") {
            //SG倉狀態需為以開票
            this.translateService.get('CreateBooking.Alert.InvoiceStatus')
              .subscribe({
                next: result => {
                  this.toastService.warn(result);
                }
              });
          } else if (respFlag == "SG_PASS") {
            this.handleDOModalImported();
          } else if (respFlag == "NOT_SG_NEED_CHECK") {
            this.isShowControlledItemModal = !this.isShowControlledItemModal;
          } else if (respFlag == "NOT_SG_PASS") {
            this.handleDOModalImported();
          } else if (respFlag == "SG_BPaaS_ERROR") {
            //BPaaS回傳管制料號憑證錯誤
            this.translateService.get('CreateBooking.Alert.BPaaSError')
              .subscribe({
                next: result => {
                  this.toastService.warn(result + respMsg);
                }
              });
          } else {
            this.isShowControlledItemModal = !this.isShowControlledItemModal;
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.toastErrorMessage(error.error);
          }
        }
      });
  }

  DOSearchModalImported(event: any): void {
    this.doImportEventData = event.data.selected;
    this.doImportOnPick = event.isActive;
    this.bookingService.isControlledItem(this.doImportEventData, this.laasSetting.facility)
      .subscribe({
        next: result => {
          this.loader.hide();
          this.isControlledItemList = result.checkLicenseNoList;
          var respFlag = result.flag;
          var respMsg = result.message;

          if (respFlag == "SG_ERP_ERROR") {
            //ERP回傳管制料號憑證錯誤
            this.translateService.get('CreateBooking.Alert.ERPError')
              .subscribe({
                next: result => {
                  this.toastService.warn(result + respMsg);
                }
              });
          } else if (respFlag == "SG_STATUS_ERROR") {
            //SG倉狀態需為以開票
            this.translateService.get('CreateBooking.Alert.InvoiceStatus')
              .subscribe({
                next: result => {
                  this.toastService.warn(result);
                }
              });
          } else if (respFlag == "SG_PASS") {
            this.handleDOModalImported();
          } else if (respFlag == "NOT_SG_NEED_CHECK") {
            this.isShowControlledItemModal = !this.isShowControlledItemModal;
          } else if (respFlag == "NOT_SG_PASS") {
            this.handleDOModalImported();
          } else if (respFlag == "SG_BPaaS_ERROR") {
            //BPaaS回傳管制料號憑證錯誤
            this.translateService.get('CreateBooking.Alert.BPaaSError')
              .subscribe({
                next: result => {
                  this.toastService.warn(result + respMsg);
                }
              });
          } else {
            this.isShowControlledItemModal = !this.isShowControlledItemModal;
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.toastErrorMessage(error.error);
          }
        }
      });
  }

  saveDoNoIntoBooking(bookingNo: string, importedDOs: any[]): void {
    this.isLoading = true;
    this.bookingService
      .saveDoNoIntoBooking(
        this.laasSetting.facility,
        importedDOs,
        this.userProfile.userName,
        bookingNo
      )
      .pipe(finalize(() => {
        this.isLoading = false;
        this.importedDOs = [];
      }))
      .subscribe({
        next: (result) => {
          this.rowData.bookingDetails = result.searchBookingDetailList;
        },
        error: (err: HttpErrorResponse) => {
          if (err.error.errorMsg) {
            this.toastErrorMessage(err.error.errorMsg);
            return;
          }
          this.toastErrorMessage(err.error);
        },
      });
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    this.bookingNo = rowData.bookingNo;
    this.bookingService
      .getBookingDetail(rowData.facility, rowData.bookingNo)
      .subscribe({
        next: (result) => {
          this.searchResults.forEach((x: any) => {
            x.doNos = [];
          });
          console.log(rowData);
          rowData.bookingDetails = [...result.searchBookingDetailList].map(
            (x: any) => {
              x.doNos = [];
              return x;
            }
          );
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  resetBtnClick(event: any): void {
    this.createDt.ngOnInit();
    this.assignDate.ngOnInit();
    this.searchForm.reset({
      facilityList: this.defaultSearchParams.facilityList,
    });
    this.parameterGroupComp.clearSelection();
    this.searchParams.createStartDt = null;
    this.searchParams.createEndDt = null;
    this.searchParams.assignStartDate = null;
    this.searchParams.assignEndDate = null;
  }

  deleteBtnClick(event: any, rowData: any): void {
    this.bookingService
      .cancelBookingCheck(this.bookingNo, rowData.doNo)
      .subscribe({
        next: (result: any) => {
          if (result?.length > 0) {
            let doNos = result.join(',  ');

            this.confirmationService.confirm({
              message: `${doNos} ${this.containerCheckDescription}`,
              rejectVisible: true,
              accept: () => {
                this.deleteBookingDetail(rowData, this.laasSetting.facility);
              },
              reject: () => {
                this.confirmationService.close();
              },
            });
          } else {
            // 確定刪除此Do?
            this.translateService
              .get('BoookingSearch.Confirm.ConfirmDeleteDO')
              .subscribe({
                next: (confirmDeleteDO) => {
                  // 確定刪除
                  this.translateService
                    .get('BoookingSearch.Confirm.ConfirmDelete')
                    .subscribe({
                      next: (confirmDelete) => {
                        this.confirmationService.confirm({
                          message: confirmDeleteDO,
                          header: confirmDelete,
                          rejectVisible: true,
                          accept: () => {
                            this.deleteBookingDetail(
                              rowData,
                              this.laasSetting.facility
                            );
                          },
                          reject: () => {
                            this.confirmationService.close();
                          },
                        });
                      },
                    });
                },
              });
          }
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  /**
   * chips add event.
   *
   * @param event p-chips onAdd event.
   * @param param
   */
  chipsAdd(event: any,param:string): void {
    const value: string = event.value;
    const parsedValues: string[] = value
      .split('\r\n')
      .filter((x) => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams[param].splice(this.searchParams[param].indexOf(0));
    this.searchParams[param] = this.searchParams[param].concat(parsedValues);
  }

  deleteBookingDetail(rowData: any, facility: string): void {
    this.bookingService
      .deleteBookingDetail(
        rowData.doNo,
        facility,
        this.bookingNo,
        this.userProfile.userName
      )
      .subscribe({
        next: (result) => {
          rowData.bookingDetails = result.searchBookingDetailList;
          if (rowData.bookingDetails.length == 0) {
            this.searchBtnClick();
          } else {
            let currentMother = this.searchResults.filter((x: any) => {
              return x.bookingNo == this.bookingNo;
            });
            if (currentMother.length > 0) {
              this.searchDetailClick({
                rowData: currentMother[0],
                expanded: false,
              });
              currentMother[0].isPickupFlag = currentMother[0].bookingDetails
                .filter((x: any) => x.doNo !== rowData.doNo)
                .some((x: any) => x.noPickingDo === '1')
                ? 1
                : 0;
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  parameterGroupChange(event: any): void {
    if (isNullOrEmpty(event)) {
      this.searchParams = deepCopy(this.defaultSearchParams);
      this.searchForm.patchValue(this.searchParams);
      this.createDt.ngOnInit();
      this.assignDate.ngOnInit();
    } else {
      this.searchParams = { ...event.data };
      this.searchForm.patchValue(this.searchParams, { emitEvent: false });
      const cStart = this.searchParams.createStartDt ? new Date(this.searchParams.createStartDt) : null;
      const cEnd = this.searchParams.createEndDt ? new Date(this.searchParams.createEndDt) : null;
      this.createDt.syncUIFromOutside([cStart, cEnd]);
      const aStart = this.searchParams.assignStartDate ? new Date(this.searchParams.assignStartDate) : null;
      const aEnd = this.searchParams.assignEndDate ? new Date(this.searchParams.assignEndDate) : null;
      this.assignDate.syncUIFromOutside([aStart, aEnd]);
    }
    this.searchForm.patchValue({ facilityList: this.searchParams.facilityList });
  }

  unBookmarked(event: any): void {
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.createDt.ngOnInit();
    this.assignDate.ngOnInit();
    this.searchForm.patchValue({ facilityList: this.searchParams.facilityList });
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split('｜').filter((x) => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  isShowDeleteIcon(): boolean {
    return (
      ['C', '5', '2'].includes(this.table.selectedRow.bookingStatus) === false &&
      this.table.selectedRow.deliveryType != 'DECLARATION' &&
      isNullOrEmpty(this.table.selectedRow.whNo)
    );
  }

  certificateBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.bookingService
      .getImportDocData(this.rowData.facility, this.rowData.bookingNo)
      .subscribe({
        next: (importDocDataList) => {
          if (importDocDataList != null) {
            // gen dataKey
            importDocDataList.forEach((item: any,index: number) => item.index = index);
            this.importDocData = importDocDataList;
            this.isShowCertificateModal = true;
          } else {
            //查無資料
            this.translateService
              .get('BoookingSearch.Success.NoDataFound')
              .subscribe({
                next: (result) => {
                  this.toastService.warn(result);
                },
              });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  certificateModal(event: any): void {
    this.importedDOs = [];
    this.isShowCertificateModal = false;
  }

  async returnTmsBtnClick(event: any, rowData: any): Promise<any> {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;

    let doNos = rowData.doNos.map((x: any) => {
      return x.doNo;
    });

    if (doNos.length == 0) {
      // 請勾選要回傳的TMS
      this.translateService
        .get('BoookingSearch.Alert.TickDOTMSReturn')
        .subscribe({
          next: (result) => {
            this.toastService.warn(result);
          },
        });
      return;
    }

    let tmsReq: any = {};
    tmsReq.facility = this.rowData.facility;
    tmsReq.bookingNo = this.rowData.bookingNo;
    tmsReq.doNos = doNos;

    let checkTMS = await this.bookingService.searchB2BTmsLog(tmsReq);
    if (checkTMS.length <= 0) {
      this.getTmsReason(tmsReq);
      return;
    }

    let message = '';
    for (let tms of checkTMS) {
      message += tms.doNo + ',';
    }
    message = message.substring(0, message.length - 1);

    // 交貨單號已回傳過 TMS，是否要重新回傳?
    this.translateService.get('BoookingSearch.Confirm.SendBack').subscribe({
      next: (sendBack) => {
        // 重新回傳 TMS
        this.translateService
          .get('BoookingSearch.Alert.ResendTMS')
          .subscribe({
            next: (resendTMS) => {
              this.confirmationService.confirm({
                message: message + sendBack,
                header: resendTMS,
                rejectVisible: true,
                accept: () => {
                  this.getTmsReason(tmsReq);
                },
                reject: () => {
                  this.confirmationService.close();
                },
              });
            },
          });
      },
    });
  }

  getTmsReason(tmsReq: any): void {
    this.tmsData = [];

    this.bookingService.getTmsReason(tmsReq).subscribe({
      next: (result) => {
        console.log('getTmsReason :', result);

        // 查無資料
        if (result == null) {
          this.translateService
            .get('BoookingSearch.Success.NoDataFound')
            .subscribe({
              next: (result) => {
                this.toastService.success(result);
              },
            });

          return;
        }

        for (let temp of result) {
          let obj: any = {};
          obj.doNo = temp.doNo;
          if (temp.message == '200') {
            obj.message = 'F-傳送成功';
          } else {
            obj.message = 'E-傳送失敗';
          }

          obj.errorMessage = this.getMappingErrorMessage(
            'TMS',
            temp.errorMessage
          );
          obj.createDt = temp.createDt;
          this.tmsData.push(obj);
        }

        this.isShowReturnTmsModal = true;
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  returnTmsModal(event: any): void {
    this.isShowReturnTmsModal = false;
  }

  returnTms(event: any, booking: any, returnTms: any): void {
    this.searchDetailClick({ rowData: booking, expanded: false });
    this.translateService.get('Common.Message.SuccessSave').subscribe({
      next: (msg) => {
        this.toastService.success(msg);
      },
    });
  }

  formatTableTitle(booking: any): string {
    return `BookingDetail - ${booking.bookingNo}`;
  }

  private fileNotExist(results: any[]): boolean {
    let isNotExist = results?.length === 0;
    isNotExist = isNotExist || results[0].attachFileDetailBeans?.length === 0;
    isNotExist = isNotExist || isNullOrEmpty(results[0].attachFileDetailBeans[0].file);
    isNotExist = isNotExist || isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName);
    return isNotExist;
  }

  private downloadShippingDocuments(
    docType: string,
    referenceType: string,
    bookingNos: string[],
    isAllowRemovePrinted: boolean,
    remark: string
  ): void {
    this.bookingService
      .downloadShippingDocuments(
        docType,
        referenceType,
        bookingNos,
        this.userProfile.loginAccount,
        isAllowRemovePrinted,
        remark
      )
      .subscribe({
        next: (results: any[]) => {
          // 無檔案可下載
          if (this.fileNotExist(results)) {
            this.translateService
              .get('BoookingSearch.Info.NoFileDownload')
              .subscribe({
                next: (result) => {
                  this.toastService.info(result);
                },
              });
            return;
          }
          for (const fileInfo of results[0].attachFileDetailBeans) {
            const byteStr = atob(fileInfo.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }
            const data: Blob = new Blob(
              [int8Array]
            );
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = fileInfo.fileName;
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        },
      });
  }

  closeFile(display: boolean): void {
    this.showDoFile = display;
    this.showDoPodFile = display;
  }

  closeBilling(display: boolean): void {
    this.isShowBillingViewerModal = display;
  }

  closeBillingPreviewCalculate(display: boolean): void {
    this.isShowBillingPreviewCalculateViewerModal = display;
  }

  private sendDHLWayBill(
    bookingNo: string,
    bookingForwarder: string,
    facility: string
  ): void {
    this.loader.show();
    this.bookingService
      .dhlWayBill({
        bookingNo: bookingNo,
        bookingForwarder: bookingForwarder,
        facility: facility,
      })
      .subscribe({
        next: (result) => {
          if (result.shipmentIdentificationNumber == null) {
            if (result.errorMsg.length > 0) {
              let msg = result.errorMsg[0];
              this.toastService.error(msg);
            } else {
              // DHL 沒有錯誤訊息
              this.translateService
                .get('BoookingSearch.Error.DHLNoError')
                .subscribe({
                  next: (result) => {
                    this.toastService.error(result);
                  },
                });
            }
          } else {
            // 提單號
            this.translateService
              .get('BoookingSearch.Success.AWBNum')
              .subscribe({
                next: (translatedResult) => {
                  this.toastService.success(
                    `${translatedResult} : ${result.shipmentIdentificationNumber}`
                  );
                },
              });
          }
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        },
      });
  }

  private sendForwarderWayBill(bookingNo: string,
    bookingForwarder: string,
    facility: string
  ): void {
    this.loader.show();
    this.bookingService
      .forwarderWayBill({
        bookingNo: bookingNo,
        bookingForwarder: bookingForwarder,
        facility: facility,
      })
      .subscribe({
        next: (result) => {
          if (isNullOrEmpty(result.masterTrackingNumber)) {
            if (result.errorMsg?.length > 0) {
              let msg = result.errorMsg[0];
              this.toastService.error(msg);
            } else {
              // forwarder 沒有錯誤訊息
              this.translateService
                .get('BoookingSearch.Alert.ForwarderWayBillUndone')
                .subscribe({
                  next: (result) => {
                    this.toastService.warn(result);
                  },
                });
            }
          } else {
            // 提單號
            this.translateService
              .get('BoookingSearch.Success.AWBNum')
              .subscribe({
                next: (translatedResult) => {
                  this.toastService.success(
                    `${translatedResult} : ${result.masterTrackingNumber}`
                  );
                },
              });
          }
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        },
      });
  }

  bookingDetailStatusChangeModal(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowBookingDetailStatusChangeModal = true;
  }

  pickUpDoBtnClick(event: any, rowData: any): void {

    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowBookingDetailPickUpChangeModel = true;
  }

  showBatchUpdateBtn(): boolean {
    return this.permissionCodes.includes(
      PermissionConstants.BatchUpdatedDeclarationBookingInfo
    );
  }

  gotoBatchUpdate(event: any): void {
    this.routeStateService.navigateTo('/TransportOperation/BatchUpdateBooking');
  }

  private downloadMergeFile(
    docTypes: Array<string>,
    referenceKeys: Array<string>
  ): void {
    this.bookingService.getDoList(referenceKeys[0]).subscribe({
      next: (doList) => {
        console.log(doList);
        doList.push(referenceKeys[0]);
        this.downloadMergeFileParams = {
          docReference: null,
          referenceKeys: doList,
          docTypes: docTypes,
          remarks: doList,
          downloadFunction: null
        };
        this.shippingDocumentService
          .downloadMergeFile(this.downloadMergeFileParams)
          .subscribe({
            next: (x) => {
              if (x.isMutipleFile == 'SINGLE') {
                const byteStr = atob(x.file);
                const arrayBuffer: ArrayBuffer = new ArrayBuffer(
                  byteStr.length
                );
                const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < byteStr.length; i++) {
                  int8Array[i] = byteStr.charCodeAt(i);
                }
                const data: Blob = new Blob([int8Array], {
                  type: 'application/octet-stream',
                });
                const url = URL.createObjectURL(data);
                const linkEle = document.createElement('a');
                linkEle.href = url;
                linkEle.download = x.fileName;
                linkEle.click();
                URL.revokeObjectURL(url);
                linkEle.remove();

                this.loader.hide();
              } else {
                const byteStr = atob(x.file);
                const arrayBuffer: ArrayBuffer = new ArrayBuffer(
                  byteStr.length
                );
                const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < byteStr.length; i++) {
                  int8Array[i] = byteStr.charCodeAt(i);
                }
                const data: Blob = new Blob([int8Array], {
                  type: 'application/zip',
                });
                const url = URL.createObjectURL(data);
                const linkEle = document.createElement('a');
                linkEle.href = url;
                linkEle.download = x.fileName;
                linkEle.click();
                URL.revokeObjectURL(url);
                linkEle.remove();
                this.loader.hide();
              }
            },
            error: (err) => {
              this.toastErrorMessage(err.error);
              this.loader.hide();
            },
            complete: () => {
              this.loader.hide();
            },
          });
      },
    });
  }

  downloadDHLInvoiceFile(request: any): void {

    this.bookingService.downloadDHLInvoiceFile(request).subscribe(result => {
      var blob = this.base64ToBlob(result.base64File);

      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `${request.bookingNo}_DHLInvoice.csv`
      link.click();
    });

  }

  downloadForwarderInvoiceFile(request: any): void {

    this.bookingService.downloadForwarderInvoiceFile(request).subscribe(result => {
      var blob = this.base64ToBlob(result.base64File);

      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = `${request.bookingNo}_ForwarderInvoice.xlsx`
      link.click();
    });

  }
  base64ToBlob(b64Data: string, sliceSize=512) {
    let byteCharacters = atob(b64Data); //data.file there
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
  }

  rePrintDocByBooking(bookings: any[]) {
    console.log(bookings)
    const bookingNoList = bookings.map((booking) => booking.bookingNo);
    console.log(bookingNoList);
    this.isLoading = true;
    this.bookingService.rePrintDocByBooking(bookingNoList, this.laasSetting.facility, this.userProfile.userName).subscribe(result => {
      if (result && result.file) {
        const byteStr = atob(result.file);
        const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
        const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteStr.length; i++) {
          int8Array[i] = byteStr.charCodeAt(i);
        }

        const data: Blob = new Blob([int8Array], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(data);
        const linkEle = document.createElement('a');
        linkEle.href = url;
        linkEle.download = `rePrintDoc_${result.fileName}`
        linkEle.click();
        URL.revokeObjectURL(url);
        linkEle.remove();
      } else {
        this.toastService.error("Download failed")
      }

      this.isLoading = false;
    })
  }

  dateOnChange(date: any, type:string) {
    switch(type){
      case "createDt" :
        this.searchParams.createStartDt = date.startDate;
        this.searchParams.createEndDt = date.endDate;
        break;
      case "assignDate":
        this.searchParams.assignStartDate = date.startDate;
        this.searchParams.assignEndDate = date.endDate;
        break;
    }
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facilityList':
        this.searchParams.facilityList = data;
        break;
    }
  }

  copyBillBooking(event: any, bookingHeaderRowData: any) {
    const rowData = this.table.selectedRow;
    if (!rowData) {
      this.loader.hide();
      return;
    }

    let doNos = rowData.doNos.map((x: any) => {
      return x.doNo;
    });

    this.copyBillingBookingRequest = {
      facility: this.laasSetting.facility,
      doNoList: doNos,
      createUser: this.userProfile.loginAccount,
      originBookingNo: rowData.bookingNo,
      redeliveryCount: 1,
      successFlag: false,
      newBooking: null,
      originBookingForwarder: rowData.bookingForwarder
    };

    this.redeliveryBooking();

  }

  redeliveryBooking() {
    this.bookingNoListString = 'newBooking';
    this.showRedeliveryBooking = true;
  }

  closeDeliveryConfirm(display: boolean): void {
    console.log(display);
    this.loader.hide();
    if(this.copyBillingBookingRequest.successFlag && !isNullOrEmpty(this.copyBillingBookingRequest.newBooking)) {
      this.searchParams = deepCopy(this.defaultSearchParams);

      this.searchParams.bookingNoList = [this.copyBillingBookingRequest.originBookingNo, this.copyBillingBookingRequest.newBooking];
      this.searchBtnClick();
    }
    this.showRedeliveryBooking = display;
  }

  showDateOnChange(event: any) {
    if (!isNullOrEmpty(event.data.createStartDt)) {
      const createStart = new Date(event.data.createStartDt);
      if (isNullOrEmpty(event.data.createEndDt)) {
        this.createDt.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.createDt.changeShowDate(createStart);
        }, 400);
      } else {
        this.createDt.changeSelectMode('Range');
        setTimeout(() => {
          this.createDt.changeShowDate([createStart, new Date(event.data.createEndDt)]);
        }, 400);
      }
    }

    if (!isNullOrEmpty(event.data.assignStartDate)) {
      const assignStartDate = new Date(event.data.assignStartDate);
      if (isNullOrEmpty(event.data.assignEndDate)) {
        this.assignDate.changeSelectMode('Start');
        setTimeout(() => {
          this.assignDate.changeShowDate(assignStartDate);
        }, 400);
      } else {
        this.assignDate.changeSelectMode('Range');
        setTimeout(() => {
          this.assignDate.changeShowDate([assignStartDate,new Date(event.data.assignEndDate),
          ]);
        }, 400);
      }
    }
  }

  generateExport(bookings: { bookingNo: string }[]) {
    const allObservables = bookings.map((booking) => this.bookingService.queryExportDeclarationFirstConditionByBookingNo(booking.bookingNo));
    forkJoin(allObservables).subscribe({
      next: (results) => {
        const ctrl = bookings.map(({ bookingNo }, i) => ({
          bookingNo,
          shippingMethod: '',
          createUser: this.userProfile.userName,
          ...results[i],
          isNeedSecondCondition: 'N',
          isNeedAutoCreateExportDeclaration: 'Y',
        }));
        this.setShippingMethods(ctrl);
        this.isShowDeliveryChooseModal = true;
      },
      error: (err) => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  createExportDeclarationAndBookingByDto(result: ExportDeclarationFirstConditionDto) {
    return this.bookingService.createExportDeclarationAndBookingByDto(result).pipe(
      tap({
        next: () => {
          this.toastService.success(`Booking[${result.bookingNo}]已產生出口報關單`);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        }
      }),
      catchError(() => {
        return of(null);
      })
    );
  }

  onSubmit() {
    const isAllShippingMethodFilled = this.shippingMethodsForm.value.shippingMethods.every((result: ExportDeclarationFirstConditionDto) => {
      return result.shippingMethod !== '';
    });
    if (!isAllShippingMethodFilled) {
      this.toastService.warn('請選擇運送方式');
      return;
    }
    this.isLoading = true;
    const allObservables = this.shippingMethodsForm.value.shippingMethods.map((result: ExportDeclarationFirstConditionDto) =>
      this.createExportDeclarationAndBookingByDto(result)
    );
    concat(...allObservables).subscribe({
      complete: () => {
        this.isShowDeliveryChooseModal = false;
        this.isLoading = false;
      }
    });
  }

  checkIsDHLExpress(){
      const rowData = this.table.selectedRow;
      if (!rowData) {
        return false;
      }

      const expressDHLForwarder = this.facilityForwarderList.find(x =>
        x.forwarderCode === rowData.bookingForwarder &&
        x.isExpress === 1 &&
        x.forwarderNameAlias.toUpperCase().includes('DHL')
      );

      return !!expressDHLForwarder;
  }

  checkControlledItemImpotred($event: any) {
    this.isShowControlledItemModal = false;
    this.handleDOModalImported();
  }

  frontlineDocBtnClick(): void {
      if (this.selectedBookings == null || this.selectedBookings == undefined || this.selectedBookings.length <= 0) {
        return;
      }
      this.frontLIneDocReferenceKeyList = [];
      this.fileCategoryForTaskDoc = FileCategory.FrontLine;
      this.canEditTable = true;
      this.canUploadDoc = true;
      this.canConfirm = true;
      const requests = this.selectedBookings.map(x =>
        this.bookingService.getDoList(x.bookingNo)
      );

      forkJoin(requests).subscribe({
        next: (results: any[][]) => {
          results.forEach(result => {
            this.frontLIneDocReferenceKeyList.push(...result);
          });

          this.openTaskDocManagement();
        },
        error: err => {
          console.error('Error fetching data:', err);
        }
      });
    }

  openTaskDocManagement(): void {
    this.isShowTaskDocManagement = true;
  }


  onShowFrontLineDoc(event: any) {
    this.frontlineDoc.resetComponent(this.frontLIneDocReferenceKeyList);
  }
  onHideFrontLineDoc(event: any) {
    // this.getProgressResult();
    this.frontlineDoc.doRemindConfirm();
  }

  private confirmQueryParamsAndPerformAutomaticQuery(): string {
      let routeExporessBill = '';
      console.log(routeExporessBill);
      this.route.queryParams.subscribe((params: Params) => {
        const paramsKeys = Object.keys(params);
        const needParams = ['expressBill'];
        if (!needParams.some((key) => paramsKeys.includes(key))) {
          return;
        }
        if (params['expressBill']) {
          const parseExpressBill = params['expressBill'].split(';').filter((parseExpressBill: any) => !isNullOrEmpty(parseExpressBill));
          if (parseExpressBill.length > 0) {
            routeExporessBill = parseExpressBill;
          }
        }
      });

      return routeExporessBill;
  }
}
